var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11281",
    "data-name": "Path 11281",
    d: "M20.356,28.052a7.7,7.7,0,1,1,7.7-7.7A7.7,7.7,0,0,1,20.356,28.052Zm0-14.238A6.542,6.542,0,1,0,26.9,20.356a6.542,6.542,0,0,0-6.542-6.542Z",
    transform: "translate(-5.356 -5.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11282",
    "data-name": "Path 11282",
    d: "M23.863,7.239a2.885,2.885,0,1,1,2.856-2.885,2.885,2.885,0,0,1-2.856,2.885Zm0-4.558a1.7,1.7,0,1,0,1.222.488A1.7,1.7,0,0,0,23.863,2.682Z",
    transform: "translate(-8.863 -0.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11283",
    "data-name": "Path 11283",
    d: "M23.906,46.242a2.856,2.856,0,1,1,2.856-2.885,2.885,2.885,0,0,1-2.856,2.885Zm0-4.558a1.731,1.731,0,1,0,1.731,1.7,1.7,1.7,0,0,0-1.731-1.7Z",
    transform: "translate(-8.906 -17.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11284",
    "data-name": "Path 11284",
    d: "M5.447,36.172a2.856,2.856,0,1,1,2.885-2.885,2.885,2.885,0,0,1-2.885,2.885Zm0-4.552a1.7,1.7,0,1,0,1.22.486A1.7,1.7,0,0,0,5.447,31.62Z",
    transform: "translate(-1.109 -12.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11285",
    "data-name": "Path 11285",
    d: "M42.407,36.172a2.856,2.856,0,1,1,2.885-2.885A2.885,2.885,0,0,1,42.407,36.172Zm0-4.552a1.7,1.7,0,1,0,1.731,1.7A1.731,1.731,0,0,0,42.407,31.62Z",
    transform: "translate(-16.745 -12.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11286",
    "data-name": "Path 11286",
    d: "M5.447,17.342a2.856,2.856,0,1,1,2.885-2.85A2.885,2.885,0,0,1,5.447,17.342Zm0-4.552a1.7,1.7,0,1,0,1.222.488,1.7,1.7,0,0,0-1.222-.488Z",
    transform: "translate(-1.108 -4.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11287",
    "data-name": "Path 11287",
    d: "M42.407,17.342a2.856,2.856,0,1,1,2.885-2.85A2.885,2.885,0,0,1,42.407,17.342Zm0-4.552a1.7,1.7,0,1,0,1.731,1.7A1.731,1.731,0,0,0,42.407,12.79Z",
    transform: "translate(-16.745 -4.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3773",
    "data-name": "Rectangle 3773",
    width: 30,
    height: 30,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableActive);
export default __webpack_public_path__ + "static/media/table_active.f28918c3b311ceb833527607edd6f35a.svg";
export { ForwardRef as ReactComponent };